import React from 'react';

/**
 * @returns {React.ReactElement} return the activity calendar component
 */
const Logout = () => {
  return <div style={{ padding: '5rem' }}>test this Logout</div>;
};
export default Logout;
